import React, { useState, useEffect } from 'react';
import './BilanReportTable.scss';
import { ArrowLeftSVG, ArrowRightSVG } from '../../../../../Components/Chika/ChikaExportSvg/ChikaExportSvg';
import DynaDatePicker from '../../../../../Components/A13/DynaView/DynaDatePicker';
import _axios from "../../../../../httpService";
import { prefixUrl } from "../../../../../utils/utilsData";
import { toast } from "react-toastify";
import Loader from "../../../../../Components/Loader2/index"

const BilanReportTable = ({ data = [] }) => {
  const [bilanData, setBilanData] = useState(data);
  const [selectedDate, setSelectedDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // پجینیشن
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const totalPages = Math.ceil(bilanData.length / rowsPerPage);
  const currentData = bilanData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };
  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const fetchBilanData = async (date) => {
    setIsLoading(true);
    const response = await _axios.get(prefixUrl() + `/cheeka/bilan-search/?request=bilan-date&date=${date}`)
    if (response?.data?.status) {
      setBilanData(response?.data?.data);
      setIsLoading(false)
    } else {
      toast.error(response?.data?.message);
      setIsLoading(false)
    }
  };

  useEffect(() => {
    if (selectedDate) {
      fetchBilanData(selectedDate);
    }
  }, [selectedDate]);

  return (
    <section className="bilan__report__table">
      <h2>گزارش بیلان</h2>
      <div className="top__section">
        {/* فیلتر تاریخ */}
        <div className="filter__date">
          <DynaDatePicker
            label={"جستجو تاریخ"}
            name={"date"}
            className={"solid-dyna-input"}
            type={"text"}
            value={selectedDate}
            setDataFromComponent={(data) => setSelectedDate(data.date)}
          />
        </div>
        {/* پجینیشن */}
        <div className="pagination__container">
          <span>نمایش</span>
          <span className="pagination__number">{rowsPerPage}</span>
          <span>سطر</span>
          <button
            className={`pagination__button prev ${currentPage !== 1 && 'active'}`}
            onClick={handlePrevPage}
            disabled={currentPage === 1}
          >
            <ArrowRightSVG />
          </button>
          <span className="pagination__number">{currentPage}</span>
          <span>از {totalPages}</span>
          <button
            className={`pagination__button next ${currentPage < totalPages && 'active'}`}
            onClick={handleNextPage}
            disabled={currentPage >= totalPages}
          >
            <ArrowLeftSVG />
          </button>
        </div>
      </div>
      {/* لودینگ */}
      {isLoading ? (
        <div className="loading">
          <Loader />
        </div>
      ) : (
        <div className="table__section">
          <div className="table__box">
            <div className="table__header">
              <div className="header__cell">ردیف</div>
              <div className="header__cell">تاریخ</div>
              <div className="header__cell">تعداد تولید</div>
              <div className="header__cell">مجموع تولید</div>
              <div className="header__cell">سود ناخالص ارزش</div>
              <div className="header__cell">سود ناخالص فی</div>
              <div className="header__cell">مجموع ارزش</div>
              <div className="header__cell">مجموع فی</div>
            </div>
            <div className="table__body">
              {currentData.length > 0 ?
                currentData?.map((v, index) => (
                  <div key={index} className="table__row">
                    <div className="table__cell">{index + 1}</div>
                    <div className="table__cell">{v?.date}</div>
                    <div className="table__cell">{Number(v?.count_production || 0).toLocaleString('fa-IR')}</div>
                    <div className="table__cell">-</div>
                    <div className="table__cell">{Number(v?.gross_profit_value || 0).toLocaleString('fa-IR')}</div>
                    <div className="table__cell">{Number(v?.gross_profit_fee || 0).toLocaleString('fa-IR')}</div>
                    <div className="table__cell">{Number(v?.total_value || 0).toLocaleString('fa-IR')}</div>
                    <div className="table__cell">{Number(v?.total_fee || 0).toLocaleString('fa-IR')}</div>
                  </div>
                )) : (
                  <p className='table__empty'>اطلاعاتی موجود نیست</p>
                )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default BilanReportTable;